import { Box, Divider, Grid, IconButton, InputAdornment, Typography, useTheme } from '@material-ui/core'
import { FileForUserGetPartyId, FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import React, { useEffect, useState } from 'react'
import { components, constants, useTranslation } from 'cng-web-lib'
import { useFormContext, useWatch } from "react-hook-form";

import CollapsibleSection from '../../../components/ui/CollapsibleSection'
import EquipmentMasterApiUrls from "../../../apiUrls/EquipmentMasterApiUrls"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NaEquipmentMasterAutoCompleteField } from 'src/components/na/autocomplete/codemaintenance'
import { NaStateCodeAutoCompleteField } from 'src/components/na'
import TemplateSelectDialog from '../../../components/aciacehighway/TemplateSelectDialog'
import makeValidationSchema from './TrailerDTOMakeValidationSchema'
import { v4 as uuid } from 'uuid'
import * as InputSource from 'src/common/InputSource'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: {
    field: {
      CngCheckboxField,
      CngTextField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const {
  filter: { LIKE, EQUAL }
} = constants

const DEFAULT_INITIAL_VALUES = Object.freeze({
  equipmentId: "",
  cargoLoadedIn: "TL",
  equipmentNumber: "",
  licensePlateNum: "",
  countryCode: "",
  saveTrailerFlag: false,
  contSealExCargoFlag: false,
  fetchTrailer: "",
  stateCode: "",
  container1: "",
  container2: "",
  container3: "",
  container4: "",
  container5: "",
  sealNo1: "",
  sealNo2: "",
  sealNo3: "",
  sealNo4: "",
  sealNo5: "",
  sealNo6: "",
  sealNo7: "",
  sealNo8: "",
  sealNo9: "",
  sealNo10: "",
  sealNo11: "",
  sealNo12: "",
  sealNo13: "",
  sealNo14: "",
  sealNo15: "",
  sealNo16: "",
  sealNo17: "",
  sealNo18: "",
  sealNo19: "",
  sealNo20: "",
  iit: "",
  lvs: "",
  postal: "",
  flyingTrucks: ""
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap
}) {
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()
  const { setValue, reset, watch } = useFormContext();
  const [templateDialog, setTemplateDialog] = useState(false)
  const theme = useTheme()
  const saveTrailerFlag = watch('saveTrailerFlag')
  const countryCode = watch("countryCode");
  const cargoLoadedIn = watch("cargoLoadedIn");
  let ignoreEquipmentTypes = ['CL', 'CU', 'CZ', '20', '2B', '40', '4B'];

  const sealNos = watch([
    'sealNo1',
    'sealNo2',
    'sealNo3',
    'sealNo4',
    'sealNo5',
    'sealNo6',
    'sealNo7',
    'sealNo8',
    'sealNo9',
    'sealNo10',
    'sealNo11',
    'sealNo12',
    'sealNo13',
    'sealNo14',
    'sealNo15',
    'sealNo16',
    'sealNo17',
    'sealNo18',
    'sealNo19',
    'sealNo20'
  ])
  const containers = watch([
    'container1',
    'container2',
    'container3',
    'container4',
    'container5'
  ])
  const exceptionCargos = watch(['iit', 'lvs', 'postal', 'flyingTrucks'])

  const [stateKey, setStateKey] = useState(uuid())

  useEffect(() => {
    setStateKey(uuid())
  }, [countryCode])

  useWatch("fileForUserId");
  useWatch("fileForUserLoginId")
  useWatch("fileForUserPartyId");
  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setValue("fileForUserId", fileForUserDetails.fileForUserId)
      setValue("fileForUserLoginId", fileForUserDetails.fileForUserLoginId)
      setValue("fileForUserPartyId", fileForUserDetails.fileForUserPartyId)
    }
  }, []);

  const columns = [
    {
      field: 'equipmentId',
      title: aciHighwayManifestTranslationText.equipmentId
    },
    {
      field: 'equipmentNo',
      title: aciHighwayManifestTranslationText.equipmentNumber
    },
    {
      field: 'equipmentType',
      title: 'Equipment type'
    },
    {
      field: 'cargoLoadedIn',
      title: aciHighwayManifestTranslationText.cargoLoadedIn
    },
  ]

  function handleApplyTemplate(template) {
    if (template) {
      const { equipmentType, equipmentNo, licensePlates } = template

      if (equipmentType) {
        if (!ignoreEquipmentTypes.includes(equipmentType)) {
          setValue('cargoLoadedIn', equipmentType === 'CH' ? 'CH' : 'TL', { shouldValidate: true })
        } else {
          setValue('cargoLoadedIn', '', { shouldValidate: true })
        }
      }

      setValue('equipmentNumber', equipmentNo || '', { shouldValidate: true })

      if (licensePlates.length > 0) {
        const { licensePlateNo, state, countryofRegistration } = licensePlates[0]

        setValue('licensePlateNum', licensePlateNo || '', { shouldValidate: true })
        setValue('stateCode', state || '', { shouldValidate: true })
        setValue('countryCode', countryofRegistration || '', { shouldValidate: true })
      }
    } else {
      reset()
    }
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <CngGridItem xs={12} lg={4} />
            <CngGridItem xs={12} lg={8}>
              <Grid container spacing={1}>
                <CngGridItem xs={12} lg={4} shouldHide={shouldHideMap.saveTrailerFlag}>
                  <CngCheckboxField
                    label={
                      <Typography variant='body2' style={{ fontSize: 12, lineHeight: 1.2 }}>
                        {aciHighwayManifestTranslationText.saveTrailerFlag}
                      </Typography>
                    }
                    name="saveTrailerFlag"
                    onChange={(e) =>
                      setValue('saveTrailerFlag', e.target.checked, { shouldValidate: true })
                    }
                    size='small'
                    style={{ marginLeft: 8, marginRight: 8, padding: 8 }}
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm shouldHide={shouldHideMap.equipmentId}>
                  <CngTextField
                    name='equipmentId'
                    label={aciHighwayManifestTranslationText.equipmentId}
                    disabled={disabled || !saveTrailerFlag}
                    inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                    onBlur={(e) => {
                      setValue('equipmentId', e.target.value.toUpperCase(), { shouldValidate: true })
                    }}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={4}>
                  <NaEquipmentMasterAutoCompleteField
                    name="fetchEquipment"
                    label={aciHighwayManifestTranslationText.fetchEquipment}
                    disabled={disabled}
                    onChange={(_, options) => handleApplyTemplate(options.data)}
                    size='small'
                    fullWidth
                    disableClearable
                    textFieldProps={{
                      InputProps: {
                        customEndAdornment: () => (
                          <InputAdornment position='end' style={{ marginTop: -16 }}>
                            <IconButton onClick={(event) => {
                              event.stopPropagation()
                              setTemplateDialog(true)
                            }}>
                              <Box display='flex' alignItems='center' justifyContent='center' width={16} height={16}>
                                <FontAwesomeIcon icon={['fal', 'money-check-edit']} size='xs' />
                              </Box>
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                    }}
                    forcePopupIcon={false}
                    lookupProps={{
                      filters: [{
                        field: 'partyId',
                        operator: EQUAL,
                        value: FileForUserGetPartyId()
                      }]
                    }}
                  />
                </CngGridItem>
              </Grid>
            </CngGridItem>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.cargoLoadedIn}>
              <CngCodeMasterAutocompleteField
                required
                name="cargoLoadedIn"
                label={aciHighwayManifestTranslationText.cargoLoadedIn}
                disabled={disabled}
                codeType='ACIHWY_TRAILER_TYPE'
                key={cargoLoadedIn}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.equipmentNumber}>
              <CngTextField
                required
                name="equipmentNumber"
                label={aciHighwayManifestTranslationText.equipmentNumber}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                onBlur={(e) => setValue("equipmentNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.licensePlateNum}>
              <CngTextField
                required
                name="licensePlateNum"
                label={aciHighwayManifestTranslationText.licensePlateNum}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 80 }}
                onBlur={(e) => setValue("licensePlateNum", e.target.value.toUpperCase(), { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.countryCode}>
              <CngCodeMasterAutocompleteField
                required
                name="countryCode"
                label={aciHighwayManifestTranslationText.countryCode}
                disabled={disabled}
                codeType='ACIHWY_MANIFEST_COUNTRY'
                key={countryCode}
                onChange={() => setValue("stateCode", "", { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.stateCode}>
              <NaStateCodeAutoCompleteField
                required
                name="stateCode"
                label={aciHighwayManifestTranslationText.stateCode}
                disabled={disabled}
                countryCode={countryCode}
                size='small'
                key={stateKey}
              />
            </CngGridItem>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection
            title={aciHighwayManifestTranslationText.containerTitle}
            defaultExpanded={containers.filter((container) => container).length > 0}
            footerText={aciHighwayManifestTranslationText.containerInfoFooterText}
            hideText={aciHighwayManifestTranslationText.containerInfoHideText}
            showText={aciHighwayManifestTranslationText.containerInfoShowText}
          >
            <Grid container spacing={1}>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.container1}>
                <CngTextField
                  name="container1"
                  label={aciHighwayManifestTranslationText.container1}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("container1", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.container2}>
                <CngTextField
                  name="container2"
                  label={aciHighwayManifestTranslationText.container2}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("container2", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.container3}>
                <CngTextField
                  name="container3"
                  label={aciHighwayManifestTranslationText.container3}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("container3", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.container4}>
                <CngTextField
                  name="container4"
                  label={aciHighwayManifestTranslationText.container4}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("container4", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.container5}>
                <CngTextField
                  name="container5"
                  label={aciHighwayManifestTranslationText.container5}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("container5", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
            </Grid>
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection
            title={aciHighwayManifestTranslationText.sealTitle}
            defaultExpanded={sealNos.filter((sealNo) => sealNo).length > 0}
            footerText={aciHighwayManifestTranslationText.sealNoFooterText}
            hideText={aciHighwayManifestTranslationText.sealNoHideText}
            showText={aciHighwayManifestTranslationText.sealNoShowText}
          >
            <Grid container spacing={1}>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo1}>
                <CngTextField
                  name="sealNo1"
                  label={aciHighwayManifestTranslationText.sealNo1}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo1", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo2}>
                <CngTextField
                  name="sealNo2"
                  label={aciHighwayManifestTranslationText.sealNo2}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo2", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo3}>
                <CngTextField
                  name="sealNo3"
                  label={aciHighwayManifestTranslationText.sealNo3}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo3", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo4}>
                <CngTextField
                  name="sealNo4"
                  label={aciHighwayManifestTranslationText.sealNo4}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo4", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo5}>
                <CngTextField
                  name="sealNo5"
                  label={aciHighwayManifestTranslationText.sealNo5}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo5", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo6}>
                <CngTextField
                  name="sealNo6"
                  label={aciHighwayManifestTranslationText.sealNo6}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo6", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo7}>
                <CngTextField
                  name="sealNo7"
                  label={aciHighwayManifestTranslationText.sealNo7}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo7", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo8}>
                <CngTextField
                  name="sealNo8"
                  label={aciHighwayManifestTranslationText.sealNo8}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo8", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo9}>
                <CngTextField
                  name="sealNo9"
                  label={aciHighwayManifestTranslationText.sealNo9}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo9", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo10}>
                <CngTextField
                  name="sealNo10"
                  label={aciHighwayManifestTranslationText.sealNo10}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo10", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo11}>
                <CngTextField
                  name="sealNo11"
                  label={aciHighwayManifestTranslationText.sealNo11}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo11", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo12}>
                <CngTextField
                  name="sealNo12"
                  label={aciHighwayManifestTranslationText.sealNo12}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo12", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo13}>
                <CngTextField
                  name="sealNo13"
                  label={aciHighwayManifestTranslationText.sealNo13}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo13", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo14}>
                <CngTextField
                  name="sealNo14"
                  label={aciHighwayManifestTranslationText.sealNo14}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo14", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo15}>
                <CngTextField
                  name="sealNo15"
                  label={aciHighwayManifestTranslationText.sealNo15}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo15", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo16}>
                <CngTextField
                  name="sealNo16"
                  label={aciHighwayManifestTranslationText.sealNo16}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo16", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo17}>
                <CngTextField
                  name="sealNo17"
                  label={aciHighwayManifestTranslationText.sealNo17}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo17", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo18}>
                <CngTextField
                  name="sealNo18"
                  label={aciHighwayManifestTranslationText.sealNo18}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo18", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo19}>
                <CngTextField
                  name="sealNo19"
                  label={aciHighwayManifestTranslationText.sealNo19}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo19", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} lg={4} shouldHide={shouldHideMap.sealNo20}>
                <CngTextField
                  name="sealNo20"
                  label={aciHighwayManifestTranslationText.sealNo20}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("sealNo20", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
            </Grid>
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection
            title={aciHighwayManifestTranslationText.exceptioncargoTitle}
            defaultExpanded={exceptionCargos.filter((exceptionCargo) => exceptionCargo).length > 0}
            footerText={aciHighwayManifestTranslationText.exemptionCargoFooterText}
            hideText={aciHighwayManifestTranslationText.exemptionCargoHideText}
            showText={aciHighwayManifestTranslationText.exemptionCargoShowText}
          >
            <Grid container spacing={1}>
              <CngGridItem xs={12} sm={6} shouldHide={false}>
                <CngTextField
                  name="iit"
                  label={aciHighwayManifestTranslationText.iit}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("iit", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={false}>
                <CngTextField
                  name="lvs"
                  label={aciHighwayManifestTranslationText.lvs}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("lvs", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={false}>
                <CngTextField
                  name="postal"
                  label={aciHighwayManifestTranslationText.postal}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("postal", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={false}>
                <CngTextField
                  name="flyingTrucks"
                  label={aciHighwayManifestTranslationText.flyingTrucks}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                  onBlur={(e) => setValue("flyingTrucks", e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
            </Grid>
          </CollapsibleSection>
        </Grid>
      </Grid>
      <TemplateSelectDialog
        columns={columns}
        defaultSorts={[{ field: 'equipmentId', direction: 'ASC' }]}
        fetch={{ url: EquipmentMasterApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() },
          { field: 'inputSource', operator: EQUAL, value: InputSource.ACI_HWY_MANIFEST }
        ]}
        onApplyTemplate={handleApplyTemplate}
        onClose={() => setTemplateDialog(false)}
        open={templateDialog}
        search={{ field: 'inputValue', operator: LIKE }}
        title='Equipment template'
      />
    </>
  )
}

const TrailerDTOFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default TrailerDTOFormProperties
